import React from 'react';
import { WarehouseCodesTemplate } from 'themes/modules/channel/pages';
import { WarehouseCodesViewStore } from 'modules/channel/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new WarehouseCodesViewStore(rootStore, componentProps),
	'warehouseCodesViewStore'
)
class WarehouseCodes extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <WarehouseCodesTemplate {...this.props} viewStore={this.props.warehouseCodesViewStore} />;
	}
}

export default WarehouseCodes;



// WEBPACK FOOTER //
// ./src/modules/channel/pages/WarehouseCodes.jsx